import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { username, password });
      localStorage.setItem("km_token", data.token);
      localStorage.setItem("km_user", data.username);
      toast.success("Zalogowano");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen bg-[#050505] text-white grain flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <a href="/" className="flex items-center gap-3 mb-10 group">
          <span className="w-9 h-9 border border-white/40 flex items-center justify-center font-serif-display">M</span>
          <span className="font-serif-display text-xl">Kamieniarstwo Mrozek</span>
        </a>

        <form onSubmit={submit} className="hairline bg-[#0a0a0a] p-8 md:p-10 space-y-6">
          <div className="flex items-center gap-3 mb-2">
            <Lock size={18} strokeWidth={1} className="text-[var(--accent)]" />
            <p className="overline">Panel administratora</p>
          </div>
          <h1 className="section-title text-white text-3xl md:text-4xl leading-tight">
            Logowanie
          </h1>

          <label className="block">
            <span className="block overline text-neutral-400 mb-2">Login</span>
            <input
              data-testid="admin-login-username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              type="text"
              autoComplete="username"
              required
              className="w-full bg-transparent border border-white/15 text-white px-4 py-3 focus:outline-none focus:border-white"
            />
          </label>

          <label className="block">
            <span className="block overline text-neutral-400 mb-2">Hasło</span>
            <input
              data-testid="admin-login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              autoComplete="current-password"
              required
              className="w-full bg-transparent border border-white/15 text-white px-4 py-3 focus:outline-none focus:border-white"
            />
          </label>

          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="btn-primary w-full justify-center disabled:opacity-50"
          >
            {loading ? <Loader2 size={14} className="animate-spin" /> : null}
            {loading ? "Logowanie..." : "Zaloguj się"}
          </button>

          <a
            href="/"
            className="block text-center text-[11px] uppercase tracking-[0.25em] text-neutral-500 hover:text-neutral-300 pt-2"
          >
            ← Powrót do strony
          </a>
        </form>
      </div>
    </main>
  );
}
